import RemoteNoteTagRepository from './repositories/RemoteNoteTagRepository'
import {ENVIRONMENTS} from '#/notes/components/definitions'

const create = function (strategy) {
  switch (strategy) {
    case ENVIRONMENTS.GEN_3:
      return new RemoteNoteTagRepository()
    case ENVIRONMENTS.GEN_2:
      // Return the gen3 repository since gen2 doesn't implement Note tags
      return new RemoteNoteTagRepository()
    default:
      return new RemoteNoteTagRepository()
  }
}

export default create
